import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, IconButton } from '@material-ui/core';
import IconExpandMore from '@material-ui/icons/ExpandMore';

import { ArrowRight } from 'src/assets/icons/ArrowRight';
import { isNegativeType } from 'src/data/brandTerm';
import { useStyles } from './useStyles';
import { TermText } from '../TermText';

export const RuleHeader = ({
  className,
  brandTerm,
  termInText,
  expanded,
  onToggleDetails,
  onApplyClick,
  disabled,
}) => {
  const styles = useStyles();

  const { approvalType } = brandTerm;

  const handleApplyClick = () => {
    onApplyClick({ brandTerm, termInText });
  };

  return (
    <div className={cx(styles.root, className, { [styles.expanded]: expanded })}>
      <div className={styles.expandContainer}>
        <IconButton
          className={styles.buttonExpand}
          onClick={onToggleDetails}
          disabled={disabled}
        >
          <IconExpandMore className={styles.iconExpand} />
        </IconButton>
      </div>

      <div className={styles.content}>
        <div className={styles.topRow}>
          {isNegativeType(approvalType) && (
            <Button
              className={styles.buttonApply}
              onClick={handleApplyClick}
              disabled={disabled}
              variant="contained"
              color="primary"
              size="small"
            >
              Apply
            </Button>
          )}
        </div>

        <div className={styles.bottomRow}>
          {isNegativeType(approvalType) ? (
            <>
              <TermText
                className={styles.termText}
                text={termInText}
                isOriginal
              />

              <ArrowRight className={styles.iconArrow} />

              <TermText
                className={styles.termText}
                text={brandTerm.replaceWith}
                isSuggestion
              />
            </>
          ) : (
            <TermText
              className={styles.termText}
              text={brandTerm.term}
            />
          )}
        </div>
      </div>
    </div>
  );
};

RuleHeader.propTypes = {
  className: PropTypes.string,
  brandTerm: PropTypes.shape().isRequired,
  termInText: PropTypes.string,
  expanded: PropTypes.bool,
  onToggleDetails: PropTypes.func.isRequired,
  onApplyClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RuleHeader.defaultProps = {
  className: '',
  termInText: '',
  expanded: false,
  disabled: false,
};
